import React, { PropTypes } from 'react';
import Units from './Unit/Units';
import { Link } from 'react-router';
import { intlShape, injectIntl } from 'react-intl';
import { Button, Row, Col, Modal, Toast } from 'routes/app/components';
import { FormattedMessage } from 'react-intl';
import {serverToDisplayDate,serverToDisplayTimeSlot} from 'app/lib/format';

class VisitBody extends React.Component {
    static propTypes = {
        chassis: PropTypes.string,
        status: PropTypes.string,
        trac: PropTypes.string,
        visit: PropTypes.string,
        dom: PropTypes.string,
        slotEta: PropTypes.string,
        slotFrom: PropTypes.string,
        slotTo: PropTypes.string,
        licensePlate: PropTypes.string,
        transName: PropTypes.string,
        units: PropTypes.array,
        removeVisit: PropTypes.func.isRequired,
        intl: intlShape
    };

    render() {
        const {intl:{formatMessage}, chassis, status, trac, visit, slotEta, dom,  slotFrom, slotTo, removeVisit, licensePlate, transName, units, ...other} = this.props;

        return (
            <div className="reg-body">
                <Row>
                    <Col className="reg-body__chassis" s={12} m={6}>

                        <div><span className="reg-body__key"><FormattedMessage id="visit.number" /> </span>{visit}</div>
                        <div><span className="reg-body__key"><FormattedMessage id="visit.terminal" /> </span>{dom}</div>
                        <div><span className="reg-body__key"><FormattedMessage id="visit.trac" /> </span>{trac}</div>
                        <div><span className="reg-body__key"><FormattedMessage id="visit.date" /> </span>{serverToDisplayDate(slotEta)}</div>
                        {slotFrom && <div><span className="reg-body__key"><FormattedMessage id="visit.timeslot" /> </span>{serverToDisplayTimeSlot(slotFrom, slotTo)}</div>}
                        {transName && <div><span className="reg-body__key"><FormattedMessage id="visit.transName.short" /> </span>{transName}</div>}
                        {licensePlate && <div><span className="reg-body__key"><FormattedMessage id="visit.licenseplate" /> </span>{licensePlate}</div>}
                        {chassis && <div><span className="reg-body__chassis__key"><FormattedMessage id="visit.chassis" />: </span>{chassis}</div>}


                    </Col>

                    {status !== 'PENDING' &&
                    <Col s={12} m={6}>
                        <div className="reg-body__actions">
                            <Link to={"/visits/" + trac}>
                                <Button className="btn-circle">
                                    <i className="material-icons">mode_edit</i>
                                </Button>
                            </Link>
                            <Modal
                                header={formatMessage({id:'visit.remove.confirm.title'})}
                                textDisagree={formatMessage({id:'visit.remove.confirm.btnCancel'})}
                                agreeElement={
                                    <Button waves="light"
                                           flat
                                           onClick={()=>{removeVisit(trac);}}
                                           modal="close">{formatMessage({id:'visit.remove.confirm.btnOK'})}</Button>
                                }
                                trigger={
                                        <Button className="btn-remove btn-circle" flat>
                                            <i className="material-icons">delete</i>
                                        </Button>
                                    }>
                                <p>{formatMessage({id:'visit.remove.confirm'})}</p>
                            </Modal>
                        </div>
                    </Col>
                    }
                </Row>
                <Row>
                    {units && <Units units={units} {...other}/>}
                </Row>
            </div>
        );
    }
}

export default injectIntl(VisitBody);
